export default __webpack_public_path__ + "d9f07d5b.png";